<template>
  <v-card
    :loading="loading"
    class="my-4"
  >
    <v-card-title class="mt-3">
      Campaigns
      <v-spacer />
      <v-text-field
        v-model="search"
        outlined
        label="Search"
        hide-details
        dense
      />
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :search="search"
        :options="{ sortBy: ['updatedDate'], sortDesc: [true] }"
        :footer-props="{
          'items-per-page-options': [50, 100, -1]
        }"
      >
        <template #[`item.typeId`]="{ item }">
          {{ campaign_type_name(item.typeId) }}
        </template>
        <template #[`item.files`]="{ item }">
          <div
            v-for="(file, i) in item.files || []"
            :key="i"
          >
            <a
              :href="file.fileUrl"
              target="_blank"
            >
              {{ file.addressCount }} - {{ file.createdDate | normalDateWithTime }}
            </a>
          </div>
        </template>
        <template #[`item.mailboxDate`]="{ item }">
          {{ item.mailboxDate | normalDate }}
        </template>
        <template #[`item.price`]="{ item }">
          {{ item.price | currency }}
        </template>
        <template #[`item.createdDate`]="{ item }">
          {{ item.createdDate | normalDateWithTime }}
        </template>
        <template #[`item.updatedDate`]="{ item }">
          {{ item.updatedDate | normalDateWithTime }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CampaignsView',

  data: () => {
    return {
      search: '',
      headers: [
        { text: 'Email', value: 'userEmail' },
        { text: 'Type', value: 'typeId' },
        { text: 'Audience', value: 'recipientCount' },
        { text: 'Price', value: 'price' },
        { text: 'Mailbox Date', value: 'mailboxDate' },
        { text: 'Uploads', value: 'files' },
        { text: 'Created', value: 'createdDate' },
        { text: 'Modified', value: 'updatedDate' }
      ],
      loading: false
    };
  },

  computed: {
    ...mapGetters({
      items: 'reports/campaigns',
      campaign_type_name: 'lookup/campaign_type_name'
    })
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch('reports/getCampaigns')
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
